import { Label, Image, Dropdown, Icon } from 'semantic-ui-react';
import styled from 'styled-components';

export const NavbarContainer = styled.div<{ isCollapsed?: boolean }>`
  width: 100%;
  height: 4em;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px 0 ${props => props.isCollapsed ? '10px' : '0'};
  transition: padding 0.3s ease;
  background-color: #fff;

  @media (max-width: 1024px) {
    padding: 12px 15px 0 ${props => props.isCollapsed ? '8px' : '0'};
  }

  @media (max-width: 768px) {
    height: 3.5em;
    padding: 10px 12px 0 0;
  }

  @media (max-width: 480px) {
    height: 3.2em;
    padding: 8px 10px 0 0;
  }
`;

export const DropdownContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  @media (max-width: 1024px) {
    gap: 8px;
  }

  @media (max-width: 768px) {
    gap: 5px;
  }
`;

export const CustomDropdownItemContainer = styled(Dropdown.Item) <{
  align: 'row' | 'column';
  hasBottomBorder?: boolean;
}>`
  display: flex !important;
  flex-direction: ${props => props.align || 'column'};
  gap: 10px;
  min-width: 260px;
  padding: 10px !important;
  border-bottom: ${props =>
    props.hasBottomBorder ? '1px solid #DDDDDD' : 'unset'} !important;
  opacity: 100 !important;
  color: #393939 !important;
  min-height: 44px; /* Touch target adequado */

  @media (max-width: 768px) {
    min-width: 240px;
    padding: 12px !important;
  }

  @media (max-width: 480px) {
    min-width: 220px;
  }
`;

export const NavbarText = styled.div<{ isCollapsed?: boolean }>`
  font-weight: bold;
  font-size: 24px;
  padding-left: ${props => props.isCollapsed ? '0.5em' : '1em'};
  transition: padding 0.3s ease;

  > h4.parent-title {
    display: block;
    color: #aaadb1;

    @media (max-width: 768px) {
      font-size: 14px;
    }

    @media (max-width: 480px) {
      font-size: 13px;
    }
  }

  @media (max-width: 1024px) {
    font-size: 20px;
  }

  @media (max-width: 768px) {
    font-size: 18px;
    padding-left: ${props => props.isCollapsed ? '0.3em' : '0.8em'};
  }

  @media (max-width: 480px) {
    font-size: 16px;
    padding-left: ${props => props.isCollapsed ? '0.2em' : '0.6em'};
  }
`;

export const UserContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: unset;
  gap: 5px;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.03);
  }

  @media (max-width: 768px) {
    padding: 6px;
    gap: 4px;
  }
`;

export const Avatar = styled(Label)`
  background-color: ${props => props.theme.main.color} !important;
  color: #ffffff !important;

  &.ui.circular.label {
    min-height: 1.5em;
    min-width: 1.5em;
    line-height: 1.5em;

    @media (max-width: 768px) {
      min-height: 2em;
      min-width: 2em;
      line-height: 2em;
      font-size: 0.9em;
    }

    @media (max-width: 480px) {
      min-height: 1.8em;
      min-width: 1.8em;
      line-height: 1.8em;
      font-size: 0.85em;
    }
  }
`;

export const UserInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
  
  @media (max-width: 1024px) {
    gap: 1px;
  }
`;

export const UserName = styled.p`
  color: #2b313c;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;

  @media (max-width: 1024px) {
    font-size: 13px;
    max-width: 150px;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    max-width: 120px;
  }
`;

export const ContentText = styled.p`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #393939;
  margin: 0;
  width: 240px;
  text-overflow: ellipsis;
  overflow: hidden;

  @media (max-width: 768px) {
    font-size: 11px;
    width: 200px;
  }

  @media (max-width: 480px) {
    font-size: 10px;
    width: 180px;
  }
`;

export const DescriptionText = styled.p<{ weight?: number }>`
  font-size: 12px;
  font-weight: ${props => props?.weight || 600};
  line-height: 16px;
  color: #808080;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;

  @media (max-width: 1024px) {
    font-size: 11px;
    max-width: 150px;
  }

  @media (max-width: 768px) {
    font-size: 10px;
    max-width: 120px;
  }
`;

export const MobileHeaderContainer = styled.div`
  display: flex;
  height: 60px;
  box-shadow: 0px 0px 7px #00000080;
  flex-direction: row;
  justify-content: space-between;
  padding: 8px 16px;
  align-items: center;
  background-color: #fff;
  position: sticky;
  top: 0;
  z-index: 100;

  @media (max-width: 480px) {
    height: 56px;
    padding: 6px 12px;
  }

  @media (max-width: 375px) {
    height: 52px;
    padding: 5px 10px;
  }
`;

export const Logo = styled(Image)`
  width: 6.5em;

  @media (max-width: 768px) {
    width: 5.5em;
  }

  @media (max-width: 480px) {
    width: 5em;
  }

  @media (max-width: 375px) {
    width: 4.5em;
  }
`;

export const IconWrapper = styled(Icon)`
  color: ${props => props.theme.main.color};
  cursor: pointer;
  padding: 4px;
  min-width: 32px;
  min-height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
  }

  @media (max-width: 768px) {
    min-width: 36px;
    min-height: 36px;
  }
`;

export const NavbarHeaderGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 1px;
  background: #dddddd;
  border-radius: 4px;
  height: 34px;
  margin-left: 8px;
`;

export const UserDropdownWrapper = styled.div<{ isAlone?: boolean }>`
  background: #ffffff;
  border-radius: ${props => (props.isAlone ? '4px' : '0 4px 4px 0')};
  display: flex;
  align-items: stretch;
  overflow: visible;

  .ui.dropdown {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
`;

export const EstateSwitcherContainer = styled.div`
  position: relative;
`;

export const EstateSwitcherTrigger = styled.button<{ isOpen: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;
  height: 40px;
  border: 0;
  border-radius: 4px 0 0 4px;
  background: ${props => (props.isOpen ? '#EDE8F5' : '#FFFFFF')};
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: #EDE8F5;
  }
`;

export const EstateTriggerMain = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  flex: 1;
  min-width: 0;
`;

export const EstateTriggerTextGroup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  min-width: 0;
`;

export const EstateNameText = styled.p<{ isSelected?: boolean }>`
  margin: 0;
  color: ${props => (props.isSelected ? '#FFFFFF' : '#2B313C')};
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
`;

export const EstateCityText = styled.p<{ isSelected?: boolean }>`
  margin: 0;
  color: ${props => (props.isSelected ? '#FFFFFF' : '#6B6F77')};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
`;

export const EstateSwitcherPanel = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 0 12px;
  position: absolute;
  top: 42px;
  left: 0;
  width: 300px;
  background: #ffffff;
  border: 1px solid #dddddd;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  z-index: 999;
`;

export const EstatePanelHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px;
  width: 100%;
`;

export const EstatePanelTitle = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  color: #393939;
`;

export const EstateSelectedCard = styled.button`
  box-sizing: border-box;
  border: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 12px;
  gap: 4px;
  background: #854ee0;
  border-bottom: 1px solid #dddddd;
  cursor: pointer;
`;

export const EstateSelectedBadge = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
`;

export const EstatePanelBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 12px;
  gap: 8px;
`;

export const EstateSearchInput = styled.input`
  width: 100%;
  height: 42px;
  border: 1px solid #dddddd;
  border-radius: 4px;
  padding: 10px;
  font-size: 12px;
  color: #2b313c;

  &::placeholder {
    color: #aaadb1;
  }
`;

export const EstateList = styled.div`
  width: 100%;
  max-height: 168px;
  overflow-y: auto;
  border-top: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
`;

export const EstateListItem = styled.button`
  width: 100%;
  border: 0;
  border-bottom: 1px solid #f1f1f1;
  background: #ffffff;
  padding: 8px 0;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  text-align: left;

  &:last-child {
    border-bottom: 0;
  }
`;
